export default __webpack_public_path__ + "static/media/hajo.ae7cabc9.png";